import { Lightning } from '@lightningjs/sdk';
import Tile, { TileTemplateSpec } from 'components/common/tiles/Tile';
import { Channel } from 'types/api/media';

export interface FavoriteChannelTileTemplateSpec extends TileTemplateSpec {
  data: Channel;
}

const TILE_WIDTH = 250;
const TILE_HEIGHT = 250;

export default class FavoriteChannelTile
  extends Tile<FavoriteChannelTileTemplateSpec>
  implements
    Lightning.Component.ImplementTemplateSpec<FavoriteChannelTileTemplateSpec>
{
  static override get width() {
    return TILE_WIDTH;
  }

  static override get height() {
    return TILE_HEIGHT;
  }

  static override get highlightWidth() {
    return TILE_WIDTH;
  }

  static override get highlightHeight() {
    return TILE_HEIGHT;
  }
}
